import HeatChart from './HeatChart';

export default HeatChart;
